import React from 'react';
import { Switch } from 'react-router-dom';
import { FourOhFourErrorPage } from '@sm/webassets';
import Layout from '~pricing/components/Layout';
import pages from '~pricing/pages';

import PricingRoutes from './PricingRoutes';
import { PricingExperimentProvider } from '~shared/hooks/usePricingExperiments';
import { PackageDataProvider } from '~shared/hooks/usePackageData';
import { PricingRouterProps } from './types';

const ROUTES = pages.map(page => {
  return page.paths.map((path: string) => {
    return <PricingRoutes key={path} path={path} exact redirectPath="/pricing" component={page.component} />;
  });
});

const PricingRouter = ({ experiments, pricingExperience }: PricingRouterProps = {}): JSX.Element => {
  return (
    <Layout>
      <PricingExperimentProvider experiments={experiments}>
        <PackageDataProvider pricingExperience={pricingExperience}>
          <Switch>
            {ROUTES}
            <FourOhFourErrorPage />
          </Switch>
        </PackageDataProvider>
      </PricingExperimentProvider>
    </Layout>
  );
};

export default PricingRouter;
